import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=171d45ad&scoped=true"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"
import style0 from "./HomeSection.vue?vue&type=style&index=0&id=171d45ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d45ad",
  null
  
)

export default component.exports